import { useState, useEffect } from 'react'
import ErrorBoundary from '../../../common/ErrorBoundary'
import parse from 'html-react-parser'
import * as useragent from 'express-useragent'
import cf from '@/lib/utils/common'
import { getHomePageData } from '../../../common/lib/Homepage'
import { getSiteData } from '../../../common/lib/auth/authhelpers'
import getSeoPagesHome from '../../../common/lib/SEO/getSeoPagesHome'
import styles from './index.module.css'
import Router, { useRouter } from 'next/router'

export default function PageTemp(props) {
  // console.log("props======>", props)
  const templateData = props?.seoPagesData?.template ? props?.seoPagesData?.template : null
  const router = useRouter()
  useEffect(() => {
    // added custom css from mo
    if (props?.seoPagesData?.css) {
      const style = document.createElement('style')
      style.innerHTML = props?.seoPagesData?.css
      document.head.appendChild(style)
    }
  }, [router.query])

  return (
    <>
      <div>
        {templateData != (null || undefined) ? (
          <ErrorBoundary>{parse(templateData)}</ErrorBoundary>
        ) : (
          <>
            <h1> Page Not Found</h1>
          </>
        )}
      </div>
    </>
  )
}

export async function getServerSideProps({ req, params }) {
  try {
    let data = {}
    let seoPagesData = null
    const slugValue = params?.index

    //await getSiteData(req)
    //const site_id = req?.headers?.site_id
    let homeData = await getHomePageData(req) // home pagedata
    //console.log('===========homeData=', homeData)

    if (!cf.isValueEmpty(homeData) && homeData.status === true && !cf.isValueEmpty(homeData.data)) {
      data = { status: true, data: homeData }
      if (slugValue) {
        seoPagesData = await getSeoPagesHome(slugValue, data.data.site.id)
        if (homeData?.data?.seo && seoPagesData?.dtls?.seo) {
          homeData.data.seo = seoPagesData?.dtls?.seo
        }
      }
    }
    if (seoPagesData?.status) {
      return {
        props: {
          isMobile: useragent.parse(req.headers['user-agent']).isMobile,
          home: data,
          site_id: data.data.site.id,
          //site_id: site_id,
          seoPagesData: seoPagesData ? seoPagesData?.dtls : null,
        },
      }
    } else {
      return {
        notFound: true,
      }
    }
  } catch (error) {
    console.log('error', error)
    return {
      props: {
        isMobile: useragent.parse(req.headers['user-agent']).isMobile,
      },
    }
  }
}
